import axios from "axios";
import { API_BASE_URL } from "../config/config";

// const currentDomain = window.location.hostname; // Örn: "localhost" veya "www.example.com"

// const API_BASE_URL = (currentDomain === 'localhost' || currentDomain === '127.0.0.1' || currentDomain === 'aiconnect.com.tr'  || currentDomain === 'demo.aiconnect.com.tr' )
//   ? 'https://apis.aiconnect.com.tr'
//   : `https://apis.${currentDomain}`;

const CustomerServices = {
  list: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      startDate: data.startDate,
      endDate: data.endDate,
    });
    return axios.get(`${API_BASE_URL}/customer/list?${params.toString()}`);
  },
  getCustomer: (data) => {
    return axios.get(
      `${API_BASE_URL}/customer/getcustomer?accountcode=${data.account}&token=${data.userToken}&userid=${data.userID}&customerid=${data.customerid}`,
    );
  },
  // getCustomerDetail : (data) => {
  //   return axios.get(
  //     `${API_BASE_URL}/getInfo?accountcode=${data.account}&token=${data.userToken}&userid=${data.userID}&customerid=${data.customerID}`
  //   )
  // },
  addressList: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      customerid: data.customerid,
    });
    return axios.get(
      `${API_BASE_URL}/customer/addresslist?${params.toString()}`,
    );
  },
  contactList: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      customerid: data.customerid,
    });
    return axios.get(
      `${API_BASE_URL}/customer/contactlist?${params.toString()}`,
    );
  },
  getInfo: (data) => {
    return axios.get(
      `${API_BASE_URL}/customer/getInfo?accountcode=${data.account}&token=${data.userToken}&userid=${data.userID}`,
    );
  },
  setContact: (data) => {
    return axios.post(`${API_BASE_URL}/customer/setcontact`, data);
  },
  setAddress: (data) => {
    return axios.post(`${API_BASE_URL}/customer/setaddress`, data);
  },
  setcustomer: (data) => {
    return axios.post(`${API_BASE_URL}/customer/setcustomer`, data);
  },
  setconnections: (data) => {
    return axios.post(`${API_BASE_URL}/customer/setconnections`, data);
  },
  deleteAddress: (data) => {
    return axios.post(`${API_BASE_URL}/customer/deleteaddress`, data);
  },
  deleteContact: (data) => {
    return axios.post(`${API_BASE_URL}/customer/deletecontact`, data);
  },
  insertMultiple: (data) => {
    return axios.post(`${API_BASE_URL}/customer/insert`, data);
  },
  insertLogInfo: (data) => {
    return axios.post(`${API_BASE_URL}/customer/insertLogInfo`, data);
  },
  customerLogList: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      customerid: data.customerid,
    });
    return axios.get(`${API_BASE_URL}/customerlog/list?${params.toString()}`);
  },
  customerAddFromFile: (data) => {
    return axios.post(`${API_BASE_URL}/customer/insertMultipleCustomer`, data);
  },
  customerAddNew: (data) => {
    return axios.post(`${API_BASE_URL}/customerlog/addnew`, data);
  },
  insert: (data) => {
    return axios.post(`${API_BASE_URL}/customerlog/insert`, data);
  },
  update: (data) => {
    return axios.post(`${API_BASE_URL}/customerlog/update`, data);
  },
  delete: (data) => {
    return axios.post(`${API_BASE_URL}/customerlog/delete`, data);
  },
  deleteCustomer: (data) => {
    return axios.post(`${API_BASE_URL}/customer/deletecustomer`, data);
  },
  changeDndStatus: (data) => {
    return axios.post(`${API_BASE_URL}/customer/changeDndStatus`, data);
  },
  downloadAll: (data) => {
    const params = new URLSearchParams({
      // start: data.start,
      // size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      startDate: data.startDate,
      endDate: data.endDate,
    });
    return axios.get(
      `${API_BASE_URL}/customer/downloadCustomer?${params.toString()}`,
    );
  },
  isThereLog: (data) => {
    return axios.post(`${API_BASE_URL}/customer/isThereLog`, data);
  },
};

export default CustomerServices;
